export class FirstStep {
    progress: number;
    isClosed: number;
    section1: any;
    section2: any;
    section3: any;
    section4: any;
    section5: any;
    section6: any;
    section7: any;
    keysList: string[];

    public constructor(init?: Partial<FirstStep>) {
        Object.assign(this, init);
        this.keysList = ['first_company', 'first_bank_account', 'first_steps_article', 'faq_section', 'using_commitly',
            'cash_flow_planning_tips', 'team_collaboration_article', 'first_team_member', 'available_categories', 'customize_categories',
            'cash_flow_template', 'get_into_planning_article', 'first_plan', 'first_budget', 'forecasts_and_controlling',
            'first_committed_plan', 'reporting_article', 'first_report'];
    }

    setFromApiModel(apiModel: any) {
        this.isClosed = apiModel.ftue_closed;
        this.section1 = {
            q1: apiModel.first_company,
            q2: apiModel.first_bank_account,
            q3: apiModel.first_steps_article,
        };
        this.section1.completed = this.section1.q1 && this.section1.q2 && this.section1.q3;
        this.section1.collapsed = this.section1.completed;

        this.section2 = {
            q4: apiModel.faq_section,
            q5: apiModel.using_commitly,
            q6: apiModel.cash_flow_planning_tips
        };
        this.section2.completed = this.section2.q4 && this.section2.q5 && this.section2.q6;
        this.section2.collapsed = this.section2.completed;

        this.section3 = {
            q7: apiModel.team_collaboration_article,
            q8: apiModel.first_team_member
        };
        this.section3.completed = this.section3.q7 && this.section3.q8;
        this.section3.collapsed = this.section3.completed;

        this.section4 = {
            q9: apiModel.available_categories,
            q10: apiModel.customize_categories,
            q11: apiModel.cash_flow_template
        };
        this.section4.completed = this.section4.q9 && this.section4.q10 && this.section4.q11;
        this.section4.collapsed = this.section4.completed;

        this.section5 = {
            q12: apiModel.get_into_planning_article,
            q13: apiModel.first_plan,
            q14: apiModel.first_budget
        };
        this.section5.completed = this.section5.q12 && this.section5.q13 && this.section5.q14;
        this.section5.collapsed = this.section5.completed;

        this.section6 = {
            q15: apiModel.forecasts_and_controlling,
            q16: apiModel.first_committed_plan
        };
        this.section6.completed = this.section6.q15 && this.section6.q16;
        this.section6.collapsed = this.section6.completed;

        this.section7 = {
            q17: apiModel.reporting_article,
            q18: apiModel.first_report
        };
        this.section7.completed = this.section7.q17 && this.section7.q18;
        this.section7.collapsed = this.section7.completed;

        let progress = 0;
        let total = 0;
        this.keysList.forEach((key) => {
            if (apiModel.hasOwnProperty(key)) {
                total++;
                if (apiModel[key]) progress++;
            }
        });
        this.progress = (progress * 100) / total;
        return this;
    }

    getNameByIndex(i: number, val?: boolean) {
        let obj = {};
        let value = val === undefined ? true : val;
        obj[i >= 0 ? this.keysList[i - 1] : 'ftue_closed'] = value;
        return obj;
    }
}
